import type { AnalysisNiche } from '../types';

/**
 * Formats a niche name for display
 * - If no '>', returns the name as-is
 * - If no duplicate last category, returns only last category
 * - If duplicate exists, returns { path: truncated path, name: last category }
 */
export const getFormattedNicheName = (
  niche: string,
  allNiches: AnalysisNiche[],
): { path?: string; name: string; hasDuplicate: boolean } => {
  // Check if niche contains category separator '>'
  if (!niche.includes('>')) {
    return { name: niche, hasDuplicate: false };
  }

  // Extract the last category
  const parts = niche.split('>').map((p) => p.trim());
  const lastCategory = parts[parts.length - 1];

  // Check if another niche ends with the same last category
  const hasDuplicate = allNiches.some((n) => {
    if (n.niche === niche) return false;
    const otherParts = n.niche.split('>').map((p) => p.trim());
    const otherLastCategory = otherParts[otherParts.length - 1];
    return otherLastCategory === lastCategory;
  });

  // Get the path without the last category
  const pathWithoutLast = parts.slice(0, -1).join(' > ');

  return {
    path: pathWithoutLast,
    name: lastCategory,
    hasDuplicate,
  };
};
